import React from "react";
import ReactDOM from "react-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import "bootstrap/dist/css/bootstrap.min.css";

import App from "./App";
// import registerServiceWorker from "./registerServiceWorker";

ReactDOM.render(
  <GoogleReCaptchaProvider
    reCaptchaKey="6LdttqgaAAAAABcSeeyg9M45UCBDnY4SyYV7HYmK"
    scriptProps={{ async: true, defer: true, appendTo: "body" }}
  >
    <App />
  </GoogleReCaptchaProvider>,
  document.getElementById("root")
);
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js